<div class="responsive-card d-flex flex-column gap-4">
  <span i18n class="responsive-card-title">Consent Waiver</span>
  <div class="d-flex flex-column gap-3">
    <app-file-list-item
      [fileName]="consentWaiverAttachment.attachment.fileName"
      [fileSizeInBytes]="consentWaiverAttachment.attachment.fileSize"
      [previewUrl]="consentWaiverAttachment.attachment | presignedUrl"
      action="download"
      (downloadClicked)="fileDownloadService.downloadAttachment(consentWaiverAttachment.attachment)" />
    <div class="review-entry-grid">
      <app-review-entry label="Date Signed" i18n-label [value]="dateSigned | date : 'MMMM d, yyyy'" />
      <app-review-entry label="Effective Date" i18n-label [value]="effectiveDate | date : 'MMMM d, yyyy'" />
    </div>
  </div>
</div>
